import * as Yup from 'yup';

export const NewTagNumberSchema = Yup.object().shape({
  hospitalId: Yup.number().required('Hastane seçimi zorunludur'),
  prefix: Yup.string().required('Ön ek zorunludur').min(1, 'Ön ek en az 1 karakter olmalıdır'),
});
